module.exports = __webpack_public_path__ + "static/img/mission_empty_img.532c9ba6.png";